import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductIntroSection() {
  return <section className="py-24 bg-charcoal text-beige relative overflow-hidden" data-id="element-211">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-212" />

      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-213">
        <div className="text-center mb-16" data-id="element-214">
          <FadeIn data-id="element-215">
            <span className="text-gold tracking-widest uppercase text-sm mb-4 block" data-id="element-216">
              Presentando
            </span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-beige-light mb-6" data-id="element-217">
              El Origen de Tus Bloqueos
            </h2>
            <p className="font-body text-lg md:text-xl text-beige/70 max-w-2xl mx-auto" data-id="element-218">
              El sistema paso a paso para identificar, comprender y liberar las
              cargas emocionales que heredaste, para que por fin puedas escribir
              tu propia historia.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} direction="up" data-id="element-219">
          <div className="relative mx-auto max-w-4xl" data-id="element-220">
            <img src="https://cdn.magicpatterns.com/uploads/emuDcq77AUTh6EKv9m3our/mockuup.png" alt="Mockup del producto El Origen de Tus Bloqueos" className="w-full h-auto drop-shadow-2xl" loading="lazy" data-id="element-221" />
          </div>
        </FadeIn>
      </div>
    </section>;
}